import { useQuery } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";
import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";

const getAttendanceData = async ({
  companyCode,
  locationCode,
  isAllCompanies = false,
  userId = 0,
  selectedCompanyCode,
  status = 0,
}) => {
    
  if (companyCode && locationCode) {
    let queryString = `?CompanyCode=${isAllCompanies ? selectedCompanyCode : companyCode}&LocationCode=${locationCode}&IsAllCompanies=${isAllCompanies}&UserId=${userId}&Status=${Number(status)}`;

    const { data } = await http_payroll.get(
      `${Api_EndPoints.GetAttentionRequiredCountList}${queryString}`,
    );
    return data;
  }

  return [];
};

export const useGetAttendanceListingQuery = (input) => {
    
  return useQuery({
    queryKey: [Api_EndPoints.GetAttentionRequiredCountList],
    queryFn: () => getAttendanceData(input),
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  });
};
